type AdSlotId = 'landing-footer' | 'game-footer';

const ENABLED = import.meta.env.VITE_ADSENSE_ENABLED === 'true';
const CLIENT = import.meta.env.VITE_ADSENSE_CLIENT as string | undefined;

/**
 * Placeholder ad slot. Renders nothing while AdSense is disabled.
 * Never place over interactive game areas (grid / keyboard).
 */
export function AdSlot({ slot }: { slot: AdSlotId }) {
  if (!ENABLED || !CLIENT) {
    return null;
  }

  return (
    <div
      className="mx-auto my-3 flex min-h-14 w-full max-w-md items-center justify-center rounded-xl border border-dashed border-dp-line/60 bg-dp-surface/40 px-3 text-xs text-dp-muted"
      data-ad-slot={slot}
      data-ad-client={CLIENT}
      aria-hidden
    >
      Ad
    </div>
  );
}
